import { Injectable } from "@angular/core";
import "rxjs/add/operator/toPromise";
//import { ServiceSettings } from '../config/service.settings';
import { AuthCookie } from "./auth-guard/auth.cookie";

@Injectable()
export class MenuService {
  constructor(private _authservice: AuthCookie) {}

  getMenu() {
    // let headers = new Headers({ Accept: 'application/json' });
    // if (this._authservice.getAuthTokenDetail !== undefined) {
    //     let userId = this._authservice.getAuthTokenDetail.User.Id;
    //     return this.dataService.get(this.serviceSettings.menuUrl + '?userid=' + userId, headers).then(res => {
    //         return res.json();
    //     });
    // } else {
    //     return null;
    // }
    return [];
  }
}
